var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuardianLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_411_9",
    "data-name": "Component 411 \\u2013 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46071",
    "data-name": "Group 46071",
    transform: "translate(-227.242 -1.152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20461",
    "data-name": "Rectangle 20461",
    width: 15,
    height: 15,
    rx: 3,
    transform: "translate(227.242 1.152)",
    fill: "#c8d0de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55493",
    "data-name": "Path 55493",
    d: "M6.486-.967a3.143,3.143,0,0,1-1.222.812A4.464,4.464,0,0,1,3.68.117,2.906,2.906,0,0,1,1.395-.794,3.94,3.94,0,0,1,.557-3.445V-4.98A4.219,4.219,0,0,1,1.327-7.7a2.721,2.721,0,0,1,2.247-.952,2.894,2.894,0,0,1,2.095.686,3.244,3.244,0,0,1,.817,2.15H4.811a1.946,1.946,0,0,0-.34-1.11,1.088,1.088,0,0,0-.844-.3,1.1,1.1,0,0,0-1.014.51,3.249,3.249,0,0,0-.328,1.623v1.547a3.174,3.174,0,0,0,.349,1.7,1.268,1.268,0,0,0,1.146.53,1.5,1.5,0,0,0,.826-.205l.152-.105V-3.187H3.551v-1.3H6.486Z",
    transform: "translate(231.686 12.801)",
    fill: "#003975"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardianLogo);
export default __webpack_public_path__ + "static/media/Guardian_Logo.511cab2bb5a22d89fecf48dff72f0b26.svg";
export { ForwardRef as ReactComponent };